import e from "./index.es242.js";
function c(n) {
  return Object.keys(n).map(function(t) {
    return "".concat(t, '="').concat(e(String(n[t])), '"');
  }).reduce(function(t, r) {
    return t + " " + r;
  }, "");
}
export {
  c as default
};
//# sourceMappingURL=index.es301.js.map
